var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEthereumLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_59_128)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 0.800006L12.6144 0.288006C12.5393 0.197974 12.4454 0.125542 12.3392 0.0758361C12.233 0.0261305 12.1172 0.000366211 12 0.000366211C11.8828 0.000366211 11.767 0.0261305 11.6608 0.0758361C11.5546 0.125542 11.4607 0.197974 11.3856 0.288006L12 0.800006ZM4.00001 10.4L3.38561 9.88801C3.27775 10.0174 3.21349 10.1776 3.202 10.3456C3.19051 10.5137 3.23237 10.6811 3.32161 10.824L4.00001 10.4ZM12 23.2L11.3216 23.624C11.3935 23.7391 11.4935 23.8339 11.6122 23.8997C11.7309 23.9655 11.8643 24 12 24C12.1357 24 12.2691 23.9655 12.3878 23.8997C12.5065 23.8339 12.6065 23.7391 12.6784 23.624L12 23.2ZM20 10.4L20.6784 10.824C20.7677 10.6811 20.8095 10.5137 20.798 10.3456C20.7865 10.1776 20.7223 10.0174 20.6144 9.88801L20 10.4ZM12 7.20001L12.2976 6.45761L12 6.33601L11.7024 6.45601L12 7.20001ZM11.3856 0.288006L3.38561 9.88801L4.61441 10.912L12.6144 1.31201L11.3856 0.288006ZM3.32161 10.824L11.3216 23.624L12.6784 22.776L4.67841 9.97601L3.32161 10.824ZM12.6784 23.624L20.6784 10.824L19.3216 9.97601L11.3216 22.776L12.6784 23.624ZM20.6144 9.88801L12.6144 0.288006L11.3856 1.31201L19.3856 10.912L20.6144 9.88801ZM4.29761 11.1424L12.2976 7.94241L11.7024 6.45601L3.70241 9.65761L4.29761 11.1424ZM11.7024 7.94241L19.7024 11.1424L20.2976 9.65761L12.2976 6.45761L11.7024 7.94241Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_59_128"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthereumLogo);
export default __webpack_public_path__ + "static/media/ethereum-logo.cc4cb95932cdb9ca23a82ce55a4f779e.svg";
export { ForwardRef as ReactComponent };